import { FETCH_LABELS_SUCCESS, LabelsPayload } from "./types";

export const fetchLabelsSuccess = (payload: LabelsPayload) => ({
  type: FETCH_LABELS_SUCCESS,
  payload,
});
